module.exports = __webpack_public_path__ + "static/media/shopping-basket.40935498.svg";